import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import useClientPrivates from 'app/client/private/private/services/ClientPrivateService';
import { Field, useFormikContext } from 'formik';
import {
  Autocomplete,
  AutocompleteRenderInputParams
} from 'formik-material-ui-lab';
import React from 'react';
import { TextField as TextFieldMaterial } from '@material-ui/core';

type Props = {
  name: string;
  className?: string;
  placeholder?: string;
  onLabelChange?: (label: string) => void;
  fullWidth?: boolean;
  margin?: 'dense' | 'normal' | 'none';
  variant?: 'outlined' | 'filled' | 'standard';
  disabled?: boolean;
  inputHeight?: string;
  valueType?: 'id' | 'object';
};

const ParticularUserSelector: React.FC<Props> = ({
  name,
  className,
  placeholder = 'Cliente',
  onLabelChange,
  fullWidth = true,
  margin = 'dense',
  variant = 'outlined',
  disabled,
  inputHeight,
  valueType = 'id'
}) => {
  const { touched, errors, setFieldValue } = useFormikContext<any>();

  const clientPrivateRepository = useClientPrivates();
  const clientesQuery = useSuperQuery(
    clientPrivateRepository.getClientPrivates
  );
  const data = clientesQuery.data ?? [];
  const options =
    valueType === 'object' ? data : data.map((x) => x.id as number);
  const loading = clientesQuery.isLoading;

  const formatClient = (client: any | null) =>
    client ? `${client.name} ${client.lastName} (${client.code})` : '';

  return (
    <Field
      name={name}
      component={Autocomplete}
      noOptionsText="No se han encontrado resultados"
      loadingText="Cargando..."
      loading={loading}
      fullWidth={fullWidth}
      margin={margin}
      className={className}
      size="medium"
      options={options as any}
      getOptionLabel={(option: any) => {
        if (valueType === 'object') {
          return formatClient(option);
        }
        const client = data.find((x) => x.id === option) ?? null;
        return formatClient(client);
      }}
      getOptionSelected={
        valueType === 'object'
          ? (option: any, value: any) => option?.id === value?.id
          : undefined
      }
      onChange={(event, value: any | null) => {
        setFieldValue(
          name,
          valueType === 'object' ? value : (value as number | null)
        );
        if (onLabelChange) {
          const client =
            valueType === 'object'
              ? (value as any | null)
              : data.find((x) => x.id === value) ?? null;
          onLabelChange(formatClient(client));
        }
      }}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextFieldMaterial
          {...params}
          error={
            Boolean((touched as any)[name]) && Boolean((errors as any)[name])
          }
          inputProps={{
            ...params.inputProps,
            style: {
              height: inputHeight
            }
          }}
          helperText={(errors as any)[name]}
          placeholder={placeholder}
          variant={variant as any}
          fullWidth={fullWidth}
          margin={margin as any}
          disabled={disabled || loading}
        />
      )}
    />
  );
};

export default ParticularUserSelector;
